// @flow
import { DateUtils } from '@tripica/date-utils';
import { differenceInCalendarDays } from 'date-fns';
import I18n from './i18n';

export const dateUtils = new DateUtils(() => I18n.locale);

const formatDaysLeft = (daysLeft: ?number, withoutIn: ?boolean): string => {
  if (daysLeft == null) return '';
  if (daysLeft > 1) {
    if (withoutIn) {
      return `${daysLeft} ${I18n.t('days')}`;
    }
    return `${I18n.t('in')} ${daysLeft} ${I18n.t('days')}`;
  } else if (daysLeft === 1) {
    return I18n.t('tomorrow');
  }
  return I18n.t('today');
};

const getRenewalDate = (timestamp: ?number, fromNow: ?boolean): ?string => {
  if (timestamp === null || timestamp === undefined) return null;
  if (fromNow) {
    const remainingDays = differenceInCalendarDays(timestamp, Date.now());
    return formatDaysLeft(remainingDays);
  }
  const dateFormat = dateUtils.getDateFormat(I18n.locale);
  return dateUtils.format(timestamp, dateFormat);
};

export const monthNames = [
  'Janvier',
  'Février.',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

export { formatDaysLeft, getRenewalDate };
